export default __webpack_public_path__ + "static/media/left-arrow.f8eff49d.svg";